const liveClassName = 'event-list-item--live';
const pastClassName = 'event-list-item--past';
const refreshInterval = 30000;
const festivalTimeZone = 'Europe/Berlin';

const programContainer = document.querySelector('[data-program]');
const nowButton = programContainer?.querySelector('[data-program-now-button]');
const filterForm = programContainer?.querySelector('#program-filters');
const filterCount = programContainer?.querySelector('[data-program-filter-count]');
const resetLink = programContainer?.querySelector('[data-program-reset]');
const filtersDialog = programContainer?.querySelector('.program-filters-dialog');
const filtersTrigger = programContainer?.querySelector('[data-program-filters-trigger]');
const filtersClose = programContainer?.querySelector('[data-program-filters-close]');

const parseDate = dateInput => {
    if (!dateInput) {
        return null;
    }

    if (/^\d+$/.test(dateInput)) {
        return new Date(Number(dateInput) * 1000);
    }

    return new Date(dateInput);
};

const overrideBaseDate = parseDate(programContainer?.dataset.nowOverride);
const hasValidOverrideBase = overrideBaseDate && !Number.isNaN(overrideBaseDate.valueOf());
const pageLoadedAt = Date.now();

const currentDate = () =>
    hasValidOverrideBase ? new Date(overrideBaseDate.getTime() + (Date.now() - pageLoadedAt)) : new Date();

const readEventEntries = () =>
    Array.from(programContainer.querySelectorAll('.event-list-item')).map(cardElement => ({
        cardElement,
        start: parseDate(cardElement.dataset.eventStart),
        end: parseDate(cardElement.dataset.eventEnd),
        badge: cardElement.querySelector('.event-list-item__live'),
    }));

const festivalDateKey = date => {
    const parts = new Intl.DateTimeFormat(undefined, {
        timeZone: festivalTimeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).formatToParts(date);
    const part = type => parts.find(p => p.type === type).value;

    return `${part('year')}-${part('month')}-${part('day')}`;
};

const isEventLive = ({ start, end }, now) => Boolean(start && start <= now && (end ? end > now : false));

const clearEventStates = eventEntries => {
    eventEntries.forEach(({ cardElement, badge }) => {
        cardElement.classList.remove(liveClassName, pastClassName);

        if (badge) {
            badge.hidden = true;
        }
    });

    return [];
};

const applyEventStates = (eventEntries, now) => {
    eventEntries.forEach(eventEntry => {
        const { cardElement, start, end, badge } = eventEntry;
        const isLive = isEventLive(eventEntry, now);
        const isPast = !isLive && Boolean(end ? end <= now : start && start <= now);

        cardElement.classList.toggle(liveClassName, isLive);
        cardElement.classList.toggle(pastClassName, isPast);

        if (badge) {
            badge.hidden = !isLive;
        }
    });

    return eventEntries.filter(eventEntry => isEventLive(eventEntry, now)).map(({ cardElement }) => cardElement);
};

let liveCardElements = [];

const refreshLiveState = () => {
    const now = currentDate();
    const todayKey = festivalDateKey(now);
    const eventEntries = readEventEntries();
    const showsCurrentDay = Boolean(
        programContainer.querySelector(`.program-hour[data-date="${todayKey}"]`),
    );
    const hasLiveEvent = eventEntries.some(eventEntry => isEventLive(eventEntry, now));

    liveCardElements =
        showsCurrentDay || hasLiveEvent ? applyEventStates(eventEntries, now) : clearEventStates(eventEntries);

    if (nowButton) {
        nowButton.hidden = liveCardElements.length === 0;
    }
};

const scrollToLiveEvent = () => {
    liveCardElements[0]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const checkboxInputs = form => Array.from(form.elements).filter(input => input.type === 'checkbox');

const countActiveFilters = () => checkboxInputs(filterForm).filter(input => input.checked).length;

const refreshFilterCount = () => {
    const activeFilterCount = countActiveFilters();
    filterCount.textContent = `${activeFilterCount}`;
    filterCount.hidden = activeFilterCount === 0;
    resetLink?.classList.toggle('program-filters-dialog__reset--muted', activeFilterCount === 0);
};

if (programContainer) {
    refreshLiveState();

    window.setInterval(refreshLiveState, refreshInterval);

    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
            refreshLiveState();
        }
    });

    nowButton?.addEventListener('click', scrollToLiveEvent);

    if (filterForm && filterCount) {
        filterForm.addEventListener('change', refreshFilterCount);
    }

    if (resetLink && filterForm) {
        const appliedFilterCount = Number(resetLink.dataset.appliedCount ?? 0);

        resetLink.addEventListener('click', event => {
            checkboxInputs(filterForm).forEach(checkbox => {
                checkbox.checked = false;
            });

            if (filterCount) {
                refreshFilterCount();
            }

            if (appliedFilterCount === 0) {
                event.preventDefault();
            }
        });
    }
}

if (filtersDialog && filtersTrigger) {
    filtersDialog.close();

    filtersTrigger.addEventListener('click', () => {
        filtersDialog.showModal();
    });

    filtersClose?.addEventListener('click', () => filtersDialog.close());

    filtersDialog.addEventListener('click', event => {
        if (event.target === filtersDialog) {
            filtersDialog.close();
        }
    });
}
